import styled from 'styled-components';
import colors from 'Styles/colors';
import { ReactComponent as CloseSVG } from 'Images/icon-close-without-background.svg';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;
Wrapper.displayName = 'Wrapper';

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > :not(:last-child) {
    margin-right: 8px;
  }
`;
HeaderRow.displayName = 'HeaderRow';

export const CloseIcon = styled(CloseSVG)`
  position: absolute;
  left: 9px;
  top: 9px;
  margin: auto;
  cursor: pointer;
  &>:hover{
    left: 8px;
    top: 8px;
    & g {
      & circle{
        background-color: ${colors.iceBlue};
      }  
    }
  }  
  & g {
    & path{
      fill: ${colors.grey19};
    }  
  }
`;
CloseIcon.displayName = 'CloseIcon';

export const CloseIconWrapper = styled.div`
  flex: 0 0 37px;
  position: relative;
  padding-left: 3px;
  height: 37px;
  cursor: pointer;
  &:hover{
    background-color: ${colors.iceBlue};
    border-radius: 50%;
  }  
`;
CloseIconWrapper.displayName = 'CloseIconWrapper';

export const VulnerabilitiesCount = styled.div`
  align-self: center;
  color: ${({ theme }) => theme.text.detailModalTitle};
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
`;
VulnerabilitiesCount.displayName = 'VulnerabilitiesCount';

export const Owned = styled.div`
  height: 25px;
  padding: 3px 9px 5px 8px;
  border-radius: 3px;
  align-self: center;
  font-size: 13px;
  font-weight: 600;
  color: ${colors.white};
  background-color: ${(props) => (props.owned ? '#e53056' : '#85c83e')};
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  &:hover {
    opacity: 0.8;
  }
`;
Owned.displayName = 'Owned';

export const MetaBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 0;
  margin-top: 16px;
  padding: 12px 14px;
  border-radius: 2px;
  background-color: #607994;
  color: ${colors.white};
  font-size: 13px;
`;
MetaBar.displayName = 'MetaBar';

export const MetaItem = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  line-height: 1.3;

  &:not(:last-child) {
    margin-right: 18px;
    padding-right: 18px;
    border-right: 1px solid rgba(255, 255, 255, 0.35);
  }
`;
MetaItem.displayName = 'MetaItem';

export const MetaLabel = styled.span`
  margin-right: 4px;
  color: rgba(255, 255, 255, 0.72);
  font-weight: 600;
`;
MetaLabel.displayName = 'MetaLabel';
